module.exports = __webpack_public_path__ + "img/SurveyIcon.8362ec2c.svg";